import { animate, style, transition, trigger } from "@angular/animations";
import { AsyncPipe } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";

import { AppRatingInteractionTrackerService } from "./app-rating-interaction-tracker.service";

@Component({
    selector: "eforsyning-app-rating-banner",
    templateUrl: "./app-rating-banner.component.html",
    styleUrls: ["./app-rating-banner.component.scss"],
    imports: [AsyncPipe],
    animations: [
        trigger("slideAnimation", [
            transition(":enter", [style({ transform: "translateY(100%)" }), animate("400ms ease-out")]),
            transition(":leave", [animate("400ms ease-in", style({ transform: "translateY(100%)" }))])
        ])
    ]
})
export class AppRatingBannerComponent implements OnInit {
    private readonly appRatingInteractionTrackerService = inject(AppRatingInteractionTrackerService);

    public readonly isVisible$ = this.appRatingInteractionTrackerService.showBanner$;

    public ngOnInit(): void {
        this.appRatingInteractionTrackerService.start();
    }

    public onYes(): void {
        void this.appRatingInteractionTrackerService.confirmAndRequestReview();
    }

    public onNo(): void {
        this.appRatingInteractionTrackerService.dismissForSession();
    }

    public onDontShowAgain(): void {
        this.appRatingInteractionTrackerService.dismissForever();
    }
}
